import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePrimaryButton, generateTertiaryButton} from '#core/application/modules/tiles/button/index.js';

export function oddsBoostsDialogFactory(PALETTE) {
    return {
        MultiOddsBoostsDialog: {
            dialog: {
                dialogContent: {
                    style: {
                        ...resolveBackground(PALETTE.OB_DIALOG_BG),
                        borderRadius: PALETTE.OB_DIALOG_BORDER_RADIUS,
                    },
                },
            },
            headerText: {
                style: PALETTE.OB_TITLE_TEXT,
            },
            // bonus item
            boosts: {
                separator: {
                    style: {
                        color: PALETTE.OB_BONUS_SEPARATOR_COLOR,
                    },
                },
            },
            title: {
                style: PALETTE.OB_BONUS_TITLE_TEXT,
            },
            text: {
                container: {
                    padding: '4px 0',
                },
                style: PALETTE.OB_BONUS_DESCRIPTION_TEXT,
            },
            expiry: {
                style: PALETTE.OB_BONUS_EXPIRATION_TEXT,
            },
            radioInput: {
                style: {
                    // Mojito hack from refbook
                    base: {
                        boxShadow: `0 0 0 1px ${PALETTE.OB_BONUS_RADIO_INPUT_COLOR}`,
                        minWidth: '16px',
                        minHeight: '16px',
                        margin: '0 1px 0 0',
                    },
                    checked: {
                        backgroundColor: PALETTE.OB_BONUS_RADIO_INPUT_COLOR,
                        borderColor: PALETTE.OB_DIALOG_BG, // yes, should be the same as dialog background
                        borderStyle: 'solid',
                        borderWidth: '2px',
                        margin: '0 1px 0 0',
                    },
                },
            },
            // footer
            buttonsContainer: {
                itemSpacing: 8,
            },
            cancelButton: generateTertiaryButton(PALETTE.OB_CANCEL_BUTTON),
            applyButton: generatePrimaryButton(PALETTE.OB_APPLY_BUTTON),
        },
    };
}
